import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { UserSearch } from '../../../users/usersearch';
import { UserDetails } from '../../../users/userdetails';
import { Games } from '../../../users/games';
import { InBondMessages } from '../../../users/Inboundmsgs';
import { OutBondMessages } from '../../../users/outbondmsgs';
import { BoundMessages } from '../../../users/bounds';
import { Statement } from '../../../users/statement';
import { CustomerHour } from '../../../users/CustomersPerHour';
import { UserDetailsLuckNumber } from '../../../users/userdetailsluckynumber';
import { UserSearchLuckyNumber } from '../../../users/usersearchluckynumber';
import { PlayersDS } from '../../../users/Players';
import { BoundWithdrawalMessages } from '../../../users/withdrawallucky';
import { BoundDepositMessages } from '../../../users/depositlucky';
import { BoundLucyMessages } from '../../../users/uckybounds';
// import { UserSearchLuckyNumber } from '../../../../users/usersearchluckynumber';
// import { CustomerHour } from '../../../../users/CustomersPerHour';

export default () => (
  <Switch>
    <Route path="/user" component={UserSearch} />
    <Route path="/userdetail" component={UserDetails} />
    <Route path="/game" component={Games} />


    <Route path="/all_message_all" component={BoundLucyMessages} />

    <Route path="/stats" component={CustomerHour} />
    <Route path="/user_details_lucky" component={UserDetailsLuckNumber} />
    <Route path="/incoming" component={InBondMessages} />
    <Route path="/outgoing" component={OutBondMessages} />
    <Route path="/allmessages" component={BoundMessages} />
    <Route path="/statement" component={Statement} />

    <Route path="/players" component={PlayersDS} />


    <Route path="/user_details_lucky_withdrawal" component={BoundWithdrawalMessages} />
    <Route path="/user_details_lucky_deposit" component={BoundDepositMessages} />



    <Route path="/user_search" component={UserSearchLuckyNumber} />

    {/* <Route path="/default_pages/faq" component={FAQ} />
    <Route path="/default_pages/gallery" component={Gallery} />
    <Route path="/default_pages/invoice_template" component={InvoiceTemplate} />
    <Route path="/default_pages/pricing_cards" component={PricingCards} />
    <Route path="/default_pages/project_summary" component={ProjectSummary} />
    <Route path="/default_pages/search_results" component={SearchResults} />
    <Route path="/default_pages/text_editor" component={TextEditor} /> */}
  </Switch>
);
